import { render, staticRenderFns } from "./BotonSeccion.vue?vue&type=template&id=48dc3eb6&"
import script from "./BotonSeccion.vue?vue&type=script&lang=js&"
export * from "./BotonSeccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports